export default __webpack_public_path__ + "static/background-books-ba29fc5e2782cd485f52f64771637ddc.jpg";